module.exports = __webpack_public_path__ + "static/media/placeholder-avatar-2.1976f646.png";